import { LoginRequest } from "../domain/requests";
import { Observable } from "rxjs";
import { Authorize, RefreshToken } from "../domain/models";
import { Injectable } from "@angular/core";


export abstract class AccountRepository {
  abstract login(request: LoginRequest): Observable<Authorize>;
  abstract refreshToken(request: RefreshToken): Observable<Authorize>;
}
